import { Action } from "@/App/actions";
import { ActionTypes } from "@/App/constants/actionTypes";

export interface UserPermissionsGetState {
  actions: Array<string>;
  loading: boolean;
}

const DEFAULT_USER_PERMISSIONS_GET_STATE: UserPermissionsGetState = {
  actions: [],
  loading: false,
};

/**
 * Reducer for user permissions state.
 *
 * The legacy Authnz logout action is removed with the deleted Authnz module.
 *
 * Note: Previously, this reducer handled AUTHNZ_USER_LOG_OUT to clear permissions.
 * That logic was removed with the Authnz module. Logout and permission clearing
 * is now handled by capitalrx-shell-auth (AuthContext) and the shell's session
 * management, which clears React state on logout without requiring Redux actions.
 * @see capitalrx-shell-auth/src/AuthContext.tsx
 */
export default (state: UserPermissionsGetState = DEFAULT_USER_PERMISSIONS_GET_STATE, action: Action): UserPermissionsGetState => {
  if (action.type === ActionTypes.GET_USER_PERMISSIONS) {
    return {
      ...state,
      loading: true,
    };
  } else if (action.type === ActionTypes.GET_USER_PERMISSIONS_RESULTS) {
    return {
      ...state,
      actions: action.payload && Array.isArray(action.payload.actions) ? action.payload.actions : [],
      loading: false,
    };
  } else {
    return state;
  }
};
